import React, {Component} from 'react';
import "../CSS/appointment.css"

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export default class ProgressBarElement extends Component {

  constructor(props) {
    super(props)
    this.navigateAppointment = this.navigateAppointment.bind(this)
  }
  navigateAppointment(stepNumber){
    if(stepNumber==1){
      if (typeof this.props.showLocation === 'function') {
        this.props.showLocation(null)
      }
    }
    if(stepNumber==2){
      if (typeof this.props.showVehicle === 'function') {
        this.props.showVehicle(null)
      }
    }
    if(stepNumber==3){
      if (typeof this.props.showService === 'function') {
        this.props.showService(null)
      }
    }
    if(stepNumber==4){
      if (typeof this.props.showDatetimeOnClick === 'function') {
        this.props.showDatetimeOnClick(null)
      }
    }
  }
  render() {
    return (
      <div style={{backgroundColor:this.props.color, color:this.props.textColor}} id={"step" + this.props.stepNumber} className = "progressBarElement" onClick={() => this.navigateAppointment(this.props.stepNumber)} >
        <div className="circle" style={{color:'black'}}>
            {this.props.stepNumber}
        </div>
        <p className="stepName">{this.props.step}</p>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/ProgressBarElement.js